import React from "react";
import { Gene, geneExpressions } from "../../types/Gene.ts";
export const GeneText = ({ gene, small = true }: { gene: Gene, small?: boolean }) => {
    let text = gene.gene_name;

    if (gene.expression !== "NORMAL") {
        text += ` (${geneExpressions.find(expression => expression.value === gene.expression)?.label})`
    }

    if (small) {
        return <div><small>{text}</small></div>
    }

    return text
}